import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetSettingsResponse,
  StartCollectingRequestsApplicationErrors,
  StartCollectingRequestsResponse,
  StopCollectingRequestsResponse,
  getSettings as universalGetSettings,
  startCollectingRequests as universalStartCollectingRequests,
  stopCollectingRequests as universalStopCollectingRequests,
} from './ecom-v1-back-in-stock-settings-back-in-stock-settings.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ecom' };

export function startCollectingRequests(
  httpClient: HttpClient
): StartCollectingRequestsSignature {
  return (appId: string) =>
    universalStartCollectingRequests(
      appId,
      // @ts-ignore
      { httpClient }
    );
}

interface StartCollectingRequestsSignature {
  /**
   * Sets `settings.collectionStates.collectingRequests` to `true` for given `appId`.
   *
   * When the collection state is set to `true`, collecting requests is enabled and customers may request
   * notifications for out of stock products. While collecting is enabled, customers see a "Notify When Available"
   * button on out-of-stock items. Customers can click the button to enter their email address, which creates the
   * notification request.
   * @param - ID of the app to start accepting notification requests for.
   *
   * Back in stock notifications only work for [Wix Stores](https://support.wix.com/en/article/wix-stores-about-wix-stores).
   * The `appId` for Wix Stores is `"215238eb-22a5-4c36-9e7b-e7c08025e04e"`.
   */
  (appId: string): Promise<
    NonNullablePaths<
      StartCollectingRequestsResponse,
      | `settings.collectionStates`
      | `settings.collectionStates.${number}.appId`
      | `settings.collectionStates.${number}.collectingRequests`,
      5
    > & {
      __applicationErrorsType?: StartCollectingRequestsApplicationErrors;
    }
  >;
}

export function stopCollectingRequests(
  httpClient: HttpClient
): StopCollectingRequestsSignature {
  return (appId: string) =>
    universalStopCollectingRequests(
      appId,
      // @ts-ignore
      { httpClient }
    );
}

interface StopCollectingRequestsSignature {
  /**
   * Sets `settings.collectionStates.collectingRequests` to `false` for given `appId`.
   *
   * When the collection state is set to `false`, collecting notification requests is disabled.
   * @param - ID of the app to stop accepting notification requests for.
   *
   * Back in stock notifications only work for [Wix Stores](https://support.wix.com/en/article/wix-stores-about-wix-stores).
   * The `appId` for Wix Stores is `"215238eb-22a5-4c36-9e7b-e7c08025e04e"`.
   */
  (appId: string): Promise<
    NonNullablePaths<
      StopCollectingRequestsResponse,
      | `settings.collectionStates`
      | `settings.collectionStates.${number}.appId`
      | `settings.collectionStates.${number}.collectingRequests`,
      5
    >
  >;
}

export function getSettings(httpClient: HttpClient): GetSettingsSignature {
  return () =>
    universalGetSettings(
      // @ts-ignore
      { httpClient }
    );
}

interface GetSettingsSignature {
  /**
   * Retrieves back in stock notification request settings.
   */
  (): Promise<
    NonNullablePaths<
      GetSettingsResponse,
      | `settings.collectionStates`
      | `settings.collectionStates.${number}.appId`
      | `settings.collectionStates.${number}.collectingRequests`,
      5
    >
  >;
}

export {
  BackInStockCollectionState,
  BackInStockSettings,
  GetSettingsRequest,
  GetSettingsResponse,
  StartCollectingRequestsRequest,
  StartCollectingRequestsResponse,
  StopCollectingRequestsRequest,
  StopCollectingRequestsResponse,
} from './ecom-v1-back-in-stock-settings-back-in-stock-settings.universal.js';
